import { render, staticRenderFns } from "./Kimono.vue?vue&type=template&id=0d3757a4&"
import script from "./Kimono.vue?vue&type=script&lang=js&"
export * from "./Kimono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports